import action from '../assets/preference/action.webp';
import adaptation from '../assets/preference/adaptation.webp';
import empathy from '../assets/preference/empathy.webp';
import experience from '../assets/preference/experience.webp';
import imagination from '../assets/preference/imagination.webp';
import interaction from '../assets/preference/interaction.webp';
import observation from '../assets/preference/observation.webp';
import organization from '../assets/preference/organization.webp';
import rationality from '../assets/preference/rationality.webp';
import reflection from '../assets/preference/reflection.webp';

export const preferenceRankColors = ['#071B45', '#212E57', '#4D597A', '#636E8B', '#808AA3'];

export const preferenceImages: Record<string, string> = {
  interaction_social: interaction,
  reflexion_social: reflection,
  experience_perceptual: experience,
  imagination_perceptual: imagination,
  empathy_emotional: empathy,
  rationality_emotional: rationality,
  observation_behavioral: observation,
  action_behavioral: action,
  organization_environmental: organization,
  adaptation_environmental: adaptation,
};

export const getPreferenceScore = (pref: any) =>
  pref.score[0].isMax ? pref.score[0].pourcentage : pref.score[1].pourcentage;

export const getPreferenceLabelColor = (index: number) => (index === 4 ? '#000B33' : '#FFFFFF');

export const getPreferenceExcerpt = (text = '') => {
  const plainText = text.replace(/<[^>]+>/g, ' ').trim();
  return plainText.match(/^[^.!?]+[.!?]/)?.[0] || plainText;
};
